"use client";

import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      richColors
      className="toaster group"
      toastOptions={{
        className: "mb-9 mr-4",
      }}
      {...props}
    />
  );
};

export { Toaster };
